import { styled } from '@mui/system';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export const FileUploadCnt = styled('section')({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'baseline'
});

export const UploadButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1)
}));

export const DataTypeDescription = styled(Typography)(({ theme }) => ({
  margin: theme.spacing(0, 1, 1, 1)
}));
